import axios from 'axios';
import { loginreq, req } from './axiosFun';
import { getHttpParams } from '../utils/util';

// 充值管理
export const getBackendFeeLog = (params) => { return req("get", "/admin/getBackendFeeLog?"+getHttpParams(params)) };

export const getAppUserCharge = (params) => { return req("get", "/admin/getAppUserCharge?"+getHttpParams(params)) };

export const getAppUserPlate = (params) => { return req("get", "/admin/getAppUserPlate?"+getHttpParams(params)) };

//新增
export const addBackendFee = (params) => { return req("get", "/admin/addBackendFee?"+getHttpParams(params)) };




// WEBPACK FOOTER //
// ./src/api/money.js